import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import userReducer from "../features/user/userSlice";
import homeReducer from "../features/home/homeSlice";
import masterReducer from "../features/master/masterSlice";
import locationReducer from "../features/location/locationSlice";
import productReducer from "../features/products/productsSlice";
import ratingReducer from "../features/rating/ratingSlice";
import cartReducer from "../features/cart/cartSlice";
import wishlistReducer from "../features/wishlist/wishlistSlice";

import orderReducer from "../features/order/orderSlice";
import aboutus from "../features/aboutus/aboutusSlice";
import career from "../features/career/careerSlice";
import careerform from "../features/career_form/careerformSlice";
import contactus from "../features/contact_us/contactusSlice";
import privacypolicy from "../features/privacypolicy/Slice";
import returnpolicy from "../features/returnpolicy/Slice";
import termsconditions from "../features/terms_conditions.js/Slice";
import faq from "../features/faq/Slice";
import blogReducer from "../features/blog/Slice";
import myaccount from "../features/my_account/Slice";
import help from "../features/help/Slice";
import socialmedia from "../features/socialmedia/Slice";

import reviewRating from "../features/review_rating/review_ratingSlice";
import wallet from "../features/wallet/walletSlice";

import colours from "../features/colour/colourSlice";
import loadingReducer from "../redux/loadingSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        home: homeReducer,
        master: masterReducer,
        location: locationReducer,   
        product: productReducer,
        rating: ratingReducer,
        cart: cartReducer,
        wishlist: wishlistReducer,
        order: orderReducer,
        aboutus: aboutus,
        career: career,
        careerform: careerform,
        contactus: contactus,
        privacypolicy:privacypolicy,
        returnpolicy: returnpolicy,
        termsconditions:termsconditions,
        faq: faq,
        blog: blogReducer,
        myaccount:myaccount,
        help: help,
        socialmedia: socialmedia,
        reviewRating: reviewRating,
        wallet: wallet,
        colours: colours,
        loading: loadingReducer
    },
});
